import { render, staticRenderFns } from "./FavoriteButton.vue?vue&type=template&id=07f92c5e&scoped=true"
import script from "./FavoriteButton.vue?vue&type=script&lang=ts"
export * from "./FavoriteButton.vue?vue&type=script&lang=ts"
import style0 from "./FavoriteButton.vue?vue&type=style&index=0&id=07f92c5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f92c5e",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/favorite-button.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FFavoriteButton.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports